import Bugsnag from "@bugsnag/js";
import type { StripeError } from "@stripe/stripe-js";

/**
 * Handles the error result of stripe.confirmPayment, shared by every Stripe checkout form.
 *
 * User-correctable errors (card_error / validation_error) are shown to the user but not reported to Bugsnag — they are
 * expected outcomes, not bugs. Anything else is unexpected: show a generic message and report it to Bugsnag with the
 * structured Stripe fields attached so the report is actionable.
 */
export function handleStripeConfirmError(
  error: StripeError,
  setError: (message: string) => void,
  onUserCorrectableError?: (error: StripeError) => void
) {
  if (error.type === "card_error" || error.type === "validation_error") {
    setError(
      error.message ||
        "Your payment could not be processed. Please check your details and try again."
    );
    onUserCorrectableError?.(error);
  } else {
    setError("An unexpected error occurred.");
    Bugsnag.notify(
      new Error(error.message || `Unexpected Stripe error (${error.type})`),
      (event) =>
        event.addMetadata("stripe", {
          type: error.type,
          code: error.code,
          declineCode: error.decline_code,
        })
    );
  }
}
